export const TokenService =
{
    getToken: function() {return localStorage.getItem("ESMToken") ?? "undefined"},
    getAuthorizationHeader: function() { return `Bearer ${TokenService.getToken()}`},
    refreshToken: async function () {
        localStorage.removeItem("ESMToken");
        window.location.reload();
      },
}